import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Grid } from "@mui/material";
import { Country, State } from "country-state-city";
import PublicIcon from "@mui/icons-material/Public";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import { CountryOption, StateOption } from "../types/authTypes";

interface CountryStateSelectProps {
  selectedCountry: string;
  selectedState: string;
  onCountryChange: (value: string) => void;
  onStateChange: (value: string) => void;
}

export const CountryStateSelect: React.FC<CountryStateSelectProps> = ({ selectedCountry, selectedState, onCountryChange, onStateChange }) => {
  const countries: CountryOption[] = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  const states: StateOption[] = selectedCountry
    ? State.getStatesOfCountry(selectedCountry).map((state) => ({
        label: state.name,
        value: state.isoCode,
      }))
    : [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth variant="standard">
          <InputLabel id="country-label" style={{ display: "flex", alignItems: "center" }}>
            <PublicIcon />
            <span style={{ marginLeft: "6px" }}>Country</span>
          </InputLabel>
          <Select labelId="country-label" value={selectedCountry} onChange={(e) => onCountryChange(e.target.value)}>
            {countries.map((country) => (
              <MenuItem key={country.value} value={country.value}>
                {country.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth variant="standard" disabled={!selectedCountry}>
          <InputLabel id="state-label" style={{ display: "flex", alignItems: "center" }}>
            <PersonPinCircleIcon />
            <span style={{ marginLeft: "6px" }}>State</span>
          </InputLabel>
          <Select labelId="state-label" value={selectedState} onChange={(e) => onStateChange(e.target.value)}>
            {states.map((state) => (
              <MenuItem key={state.value} value={state.value}>
                {state.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};
